import { ApolloQueryResult } from "apollo-client";
import { Intent, IntentProvider } from "core/components/IntentContext";
import IQueryService, { QueryAlias } from "core/service/query/IQueryService";
import Class from 'core/util/Class';
import React from "react";
import { QueryType } from "typegraph";
import Logger from "../util/Logger";
import { makeCancelable } from "../util/PromiseUtil";
import ServiceRegistry from "../util/ServiceRegistry";

// values passed to chidlren render function
interface IQueryArgs<DataType, ParamsType> {
	data: DataType | null;
	doQuery: (params: ParamsType) => void;
	errors?: any[];
	loading: boolean;
	refetch: () => void;
}

// result component from queryOne or queryMany
export interface ITypedQueryProps<DataType, ParamsType = {}> {
	autoLoad?: boolean; // default true
	children: (args: IQueryArgs<DataType, ParamsType>) => React.ReactNode;
	params: ParamsType;
	variables?: any;
}

// inner component props and state
interface IQueryProps<DataType, ParamsType = {}> extends ITypedQueryProps<DataType, ParamsType> {
	entity: Class<any>;
	type: QueryType;
}

interface IQueryState<DataType> {
	response: ApolloQueryResult<DataType>;
}

export class Query<DataType, ParamsType> extends React.Component<IQueryProps<DataType, ParamsType>, IQueryState<DataType>> {

	public static queryMany<DataType, ParamsType>(entity: Class<any>): React.StatelessComponent<ITypedQueryProps<DataType[], ParamsType>> {
		return this.getQueryClass<DataType[], ParamsType>(entity, QueryType.MANY);
	}

	public static queryOne<DataType, ParamsType>(entity: Class<any>): React.StatelessComponent<ITypedQueryProps<DataType, ParamsType>> {
		return this.getQueryClass<DataType, ParamsType>(entity, QueryType.ONE);
	}

	private static getQueryClass<DataType, ParamsType>(entity: Class<any>, type: QueryType): React.StatelessComponent<ITypedQueryProps<DataType, ParamsType>> {
		const TypedQuery = Query as new (props: ITypedQueryProps<DataType, ParamsType>) => Query<DataType, ParamsType>;

		return (props: ITypedQueryProps<DataType, ParamsType>) => <TypedQuery entity={entity} type={type} {...props} />;
	}

	private promise: any;

	constructor(props: IQueryProps<DataType, ParamsType>) {
		super(props);
		this.state = { response: {} as ApolloQueryResult<DataType> };

		// preload logic

		// check the registry for


	}

	public render() {
		const { data, errors, loading } = this.state.response;

		// this causes it so spin on errors too?
		// nvm its needed for skeleton for now
		const isLoading = loading ? loading : (!data && !errors);

		return (
			<IntentProvider intent={isLoading && Intent.LOADING}>
				{this.props.children({
						data: data ? ( QueryType.MANY === this.props.type ? data[QueryAlias.MANY] : data[QueryAlias.ONE] ) : null,
						doQuery: this.doQuery,
						errors,
						loading: isLoading,
						refetch: this.refetch
				})}
			</IntentProvider>
		);
	}

	public componentDidMount() {
		this.doQuery(this.props.params, this.props.variables);
	}

	public componentWillUnmount() {
		if (this.promise) {
			this.promise.cancel();
		}
	}

	private refetch = () => {
		this.doQuery(this.props.params, this.props.variables);
	}

	private doQuery = (params: ParamsType, variables?: any) => {
		const { entity, type } = this.props;

		// const aliasedQuery = generateQuery(entity, type, { params }, (QueryType.MANY === type ? QueryAlias.MANY : QueryAlias.ONE));

		const queryPromise = ServiceRegistry.get(IQueryService).find(type, entity, params, variables);

		this.promise = makeCancelable(queryPromise);

		this.promise.promise.then((response) => this.setState({ response })).catch(() => Logger.debug("Query promise cancelled"));
	}
}



// WEBPACK FOOTER //
// ./src/core/api/typedQuery.tsx